<template>
    <PageApp namePage="no-permission-page" title="Usuário sem permissão">
        <v-column class="text-center">
            <v-alert dense type="warning">
                Você não possui permissão para acessar a página
            </v-alert>
            <v-btn @click="voltarInicio" :color="consts.corNeutraEscura" outlined>
                Voltar para o início
            </v-btn>
        </v-column>
    </PageApp>
</template>

<script>
import PageApp from '@/components/templates/PageApp'
import consts from '@/globalFiles/consts'

export default {
    name: 'NoPermissionPage',
    components: {
        PageApp
    },
    data() {
        return {
            consts
        }
    },
    methods: {
        voltarInicio() {
            this.$router.push({
                name: 'profissional'
            })
        }
    }
}
</script>

<style>

</style>